import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.missions');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { normalizeWorkflowStatusKey, workflowStatusClass, workflowStatusCssClass, workflowStatusLabel } from '../shared/workflow-status';

@Component({
    selector: 'wiz-page-missions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.missions/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

:host * {
  box-sizing: border-box;
}

.mission-control-screen {
  height: 100%;
  min-height: calc(100vh - var(--ops-topbar-height));
  overflow: hidden;
  background: #091411;
  color: #f6fbf8;
  word-break: keep-all;
}

.mission-control-stage {
  position: relative;
  min-height: calc(100vh - var(--ops-topbar-height));
}

.mission-alert-strip {
  position: absolute;
  z-index: 40;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  border: 1px solid rgba(228, 207, 149, 0.72);
  border-radius: 8px;
  background: rgba(251, 244, 223, 0.95);
  color: #6f4a09;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
}

.mission-map-plane {
  position: relative;
  min-height: calc(100vh - var(--ops-topbar-height));
  margin-right: 364px;
  overflow: hidden;
  background: #dce5dc;
  isolation: isolate;
}

.mission-map-tile,
.mission-map-texture,
.mission-map-shade,
.command-map-grid,
.mission-route-layer {
  position: absolute;
  inset: 0;
}

.mission-map-tile {
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.96;
  filter: saturate(1.08) contrast(1.02);
}

.mission-map-texture {
  z-index: 1;
  background: linear-gradient(117deg, rgba(23, 64, 43, 0.18), transparent 28%, rgba(20, 84, 116, 0.13) 72%, transparent), repeating-linear-gradient(28deg, rgba(255, 255, 255, 0.08) 0 1px, transparent 1px 15px), repeating-linear-gradient(142deg, rgba(10, 33, 22, 0.08) 0 1px, transparent 1px 20px), linear-gradient(135deg, #d8e1d9, #f2f4ec 48%, #cddbcf);
  opacity: 0.42;
}

.mission-map-shade {
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(8, 20, 16, 0.32), transparent 24%, transparent 74%, rgba(8, 20, 16, 0.2)), linear-gradient(180deg, rgba(255, 255, 255, 0.14), transparent 38%, rgba(9, 20, 17, 0.2));
}

.command-map-grid {
  z-index: 3;
  pointer-events: none;
  background: linear-gradient(rgba(15, 23, 42, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(15, 23, 42, 0.1) 1px, transparent 1px);
  background-size: 54px 54px;
  mask-image: linear-gradient(to bottom, transparent, #000 12%, #000 86%, transparent);
}

.mission-map-header {
  position: absolute;
  z-index: 15;
  top: 16px;
  left: 16px;
  right: 16px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  color: #ffffff;
}

.mission-back-button {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 8px;
  background: rgba(12, 24, 19, 0.68);
  color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  font-size: 20px;
  font-weight: 900;
  text-decoration: none;
  backdrop-filter: blur(10px);
}

.mission-back-button:disabled {
  cursor: not-allowed;
  opacity: 0.46;
}

.mission-map-title {
  min-width: 0;
  border-left: 3px solid #6ee7b7;
  padding-left: 13px;
  text-shadow: 0 2px 16px rgba(4, 12, 8, 0.38);
}

.mission-map-title p,
.mission-panel-brand p,
.mission-panel-route span,
.mission-panel-section-head span,
.mission-map-telemetry span,
.mission-dock-panel summary span,
.mission-source-ledger span,
.mission-upload-main span,
.mission-empty-screen p,
.mission-selection-title p {
  font-size: 11px;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: 0;
}

.mission-map-title p {
  color: rgba(232, 244, 238, 0.86);
}

.mission-map-title h1 {
  margin-top: 4px;
  overflow: hidden;
  color: #ffffff;
  font-size: 38px;
  font-weight: 900;
  line-height: 1.08;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-map-title span {
  display: block;
  margin-top: 6px;
  overflow: hidden;
  color: rgba(248, 252, 250, 0.86);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-map-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}

.mission-map-meta span {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 999px;
  background: rgba(12, 24, 19, 0.58);
  color: #ffffff;
  padding: 0 11px;
  font-size: 11px;
  font-weight: 900;
  backdrop-filter: blur(10px);
}

.mission-live-status {
  position: absolute;
  z-index: 15;
  top: 108px;
  left: 16px;
  display: grid;
  min-width: 286px;
  gap: 5px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  background: rgba(17, 23, 20, 0.82);
  color: #ffffff;
  padding: 14px 16px;
  box-shadow: 0 18px 42px rgba(4, 12, 8, 0.24);
  backdrop-filter: blur(12px);
}

.mission-live-status span,
.mission-live-status em {
  color: rgba(234, 244, 239, 0.82);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
}

.mission-live-status strong {
  color: #ffffff;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.2;
}

.mission-live-status.is-running {
  border-color: rgba(186, 230, 253, 0.58);
  background: rgba(13, 55, 79, 0.86);
}

.mission-live-status.is-uploading {
  border-color: rgba(252, 211, 77, 0.58);
  background: rgba(92, 64, 9, 0.86);
}

.mission-live-status.is-complete {
  border-color: rgba(167, 243, 208, 0.62);
  background: rgba(9, 78, 45, 0.86);
}

.mission-route-layer {
  z-index: 5;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.mission-map-route-base {
  stroke: rgba(36, 48, 41, 0.76);
  stroke-width: 1.55;
  stroke-dasharray: 2.6 2.6;
}

.mission-map-route-done {
  stroke: #1f7a4d;
  stroke-width: 3.15;
  filter: drop-shadow(0 4px 8px rgba(31, 122, 77, 0.24));
}

.mission-map-route-active {
  stroke: #1f5f8b;
  stroke-width: 3.65;
  filter: drop-shadow(0 5px 10px rgba(31, 95, 139, 0.3));
}

.mission-map-marker {
  position: absolute;
  z-index: 8;
  transform: translate(-50%, -50%);
  display: inline-flex;
  min-width: 42px;
  height: 29px;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #525b55;
  color: #ffffff;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.28);
  font-size: 11px;
  font-weight: 900;
  transition: background 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.mission-map-launch {
  z-index: 9;
  background: #1f7a4d;
}

.mission-map-pending {
  background: #525b55;
}

.mission-map-current {
  z-index: 10;
  background: #1f5f8b;
  box-shadow: 0 0 0 6px rgba(31, 95, 139, 0.18), 0 18px 32px rgba(31, 95, 139, 0.3);
}

.mission-map-done {
  background: #1f7a4d;
}

.mission-map-retake {
  background: #9a6a12;
  box-shadow: 0 0 0 6px rgba(154, 106, 18, 0.2), 0 18px 32px rgba(154, 106, 18, 0.26);
}

.mission-map-focus {
  transform: translate(-50%, -50%) scale(1.12);
}

.mission-drone-marker {
  position: absolute;
  z-index: 12;
  display: inline-flex;
  min-width: 98px;
  max-width: 156px;
  align-items: center;
  gap: 8px;
  transform: translate(-50%, -50%);
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #1f5f8b;
  color: #ffffff;
  padding: 8px 11px 8px 8px;
  box-shadow: 0 0 0 7px rgba(31, 95, 139, 0.18), 0 20px 38px rgba(31, 95, 139, 0.34);
  transition: left 420ms ease, top 420ms ease, background 180ms ease, box-shadow 180ms ease;
}

.mission-drone-dot {
  position: relative;
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  border-radius: 999px;
  background: #eaf3f8;
  box-shadow: inset 0 0 0 6px #1f5f8b;
}

.mission-drone-dot::before,
.mission-drone-dot::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 34px;
  height: 4px;
  border-radius: 999px;
  background: rgba(224, 242, 254, 0.96);
  transform: translate(-50%, -50%);
}

.mission-drone-dot::after {
  width: 4px;
  height: 34px;
}

.mission-drone-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 900;
}

.mission-drone-idle,
.mission-drone-return,
.mission-drone-upload {
  background: #525b55;
  box-shadow: 0 18px 34px rgba(82, 91, 85, 0.3);
}

.mission-drone-complete {
  background: #1f7a4d;
  box-shadow: 0 18px 34px rgba(31, 122, 77, 0.3);
}

.mission-map-telemetry {
  position: absolute;
  z-index: 15;
  left: 16px;
  right: 16px;
  bottom: 96px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.mission-map-telemetry div {
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.88);
  color: #111714;
  padding: 9px 11px;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.16);
  backdrop-filter: blur(10px);
}

.mission-map-telemetry span {
  display: block;
  color: #65706a;
}

.mission-map-telemetry strong {
  display: block;
  margin-top: 5px;
  overflow: hidden;
  color: #111714;
  font-size: 13px;
  font-weight: 900;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-bottom-dock {
  position: absolute;
  z-index: 18;
  left: 16px;
  right: 16px;
  bottom: 16px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 7px;
}

.mission-dock-panel,
.mission-status-event {
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  background: rgba(17, 23, 20, 0.86);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(4, 12, 8, 0.22);
  backdrop-filter: blur(12px);
}

.mission-dock-panel summary {
  display: flex;
  min-height: 42px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 12px;
  list-style: none;
}

.mission-dock-panel summary::-webkit-details-marker {
  display: none;
}

.mission-dock-panel summary span {
  color: rgba(232, 244, 238, 0.78);
}

.mission-dock-panel summary strong {
  overflow: hidden;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-dock-panel[open] summary {
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
}

.mission-point-ledger,
.mission-source-ledger,
.mission-log-ledger,
.mission-upload-ledger {
  max-height: 190px;
  overflow: auto;
  padding: 10px;
}

.mission-point-row,
.mission-source-ledger div,
.mission-log-ledger div {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) minmax(96px, auto) 66px;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 6px 0;
}

.mission-point-row:last-child,
.mission-source-ledger div:last-child,
.mission-log-ledger div:last-child {
  border-bottom: 0;
}

.mission-point-row span,
.mission-source-ledger span,
.mission-log-ledger span {
  color: rgba(234, 244, 239, 0.78);
  font-size: 11px;
  font-weight: 900;
}

.mission-point-row strong,
.mission-source-ledger strong,
.mission-log-ledger strong {
  min-width: 0;
  overflow: hidden;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-point-row em,
.mission-log-ledger em {
  overflow: hidden;
  color: rgba(234, 244, 239, 0.72);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-point-row small {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.13);
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
}

.mission-point-row.done small,
.mission-log-ledger .done em {
  background: rgba(31, 122, 77, 0.92);
  color: #ffffff;
}

.mission-point-row.moving small,
.mission-point-row.capturing small,
.mission-log-ledger .current em {
  background: rgba(31, 95, 139, 0.92);
  color: #ffffff;
}

.mission-point-row.retake small {
  background: rgba(154, 106, 18, 0.96);
  color: #ffffff;
}

.mission-point-actions {
  grid-column: 1/-1;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}

.mission-point-actions button {
  min-height: 28px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 900;
}

.mission-source-ledger div,
.mission-log-ledger div {
  grid-template-columns: 72px minmax(0, 1fr) 70px;
}

.mission-upload-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px 12px;
  align-items: center;
}

.mission-upload-main span,
.mission-upload-ledger p {
  color: rgba(234, 244, 239, 0.82);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.45;
}

.mission-upload-main strong {
  color: #ffffff;
  font-size: 24px;
  font-weight: 900;
}

.mission-upload-main .mission-progress-track {
  grid-column: 1/-1;
}

.mission-upload-ledger p {
  margin-top: 8px;
}

.mission-dock-panel-alert {
  border-color: rgba(252, 211, 77, 0.52);
}

.mission-status-event {
  display: flex;
  min-height: 48px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 0 13px;
}

.mission-status-event span,
.mission-status-event a {
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
}

.mission-status-event a {
  text-decoration: underline;
  text-underline-offset: 3px;
}

.mission-control-panel {
  position: absolute;
  z-index: 30;
  top: 14px;
  right: 14px;
  bottom: 14px;
  display: flex;
  width: 336px;
  flex-direction: column;
  overflow: auto;
  border: 1px solid rgba(255, 255, 255, 0.76);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  color: #111714;
  box-shadow: 0 26px 58px rgba(4, 12, 8, 0.32);
  backdrop-filter: blur(18px);
}

.mission-panel-brand,
.mission-panel-route,
.mission-panel-readiness,
.mission-panel-progress,
.mission-panel-switcher {
  padding: 14px 16px;
}

.mission-panel-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #d9dedb;
}

.mission-panel-brand p {
  color: #1f5f8b;
}

.mission-panel-brand span {
  overflow: hidden;
  color: #65706a;
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-panel-route {
  border-bottom: 1px solid #d9dedb;
  background: #111714;
  color: #ffffff;
}

.mission-panel-route span {
  color: rgba(232, 244, 238, 0.76);
}

.mission-panel-route h2 {
  margin-top: 8px;
  color: #ffffff;
  font-size: 21px;
  font-weight: 900;
  line-height: 1.22;
}

.mission-panel-route p {
  margin-top: 10px;
  color: rgba(232, 244, 238, 0.82);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.45;
}

.mission-panel-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.mission-panel-section-head span {
  color: #65706a;
}

.mission-panel-section-head strong {
  color: #111714;
  font-size: 13px;
  font-weight: 900;
}

.mission-readiness-meter,
.mission-progress-track {
  position: relative;
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #ecefed;
}

.mission-readiness-meter {
  margin-top: 12px;
}

.mission-readiness-meter i,
.mission-progress-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #1f7a4d;
}

.mission-readiness-list {
  display: grid;
  gap: 6px;
  margin-top: 10px;
}

.mission-readiness-list div {
  display: grid;
  grid-template-columns: minmax(70px, 0.72fr) minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  min-height: 30px;
  border-bottom: 1px solid #e6e9e7;
  padding-bottom: 7px;
}

.mission-readiness-list div:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.mission-readiness-list span {
  color: #65706a;
  font-size: 11px;
  font-weight: 900;
}

.mission-readiness-list strong {
  overflow: hidden;
  color: #111714;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-readiness-list em {
  display: inline-flex;
  min-height: 22px;
  align-items: center;
  border-radius: 999px;
  padding: 0 8px;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
}

.mission-readiness-list .is-ok em {
  background: #e8f4ee;
  color: #1f7a4d;
}

.mission-readiness-list .is-blocked em {
  background: #fbf4df;
  color: #9a6a12;
}

.mission-panel-readiness,
.mission-panel-progress {
  border-bottom: 1px solid #d9dedb;
}

.mission-progress-number {
  margin-top: 12px;
  color: #111714;
  font-size: 48px;
  font-weight: 900;
  line-height: 1;
}

.mission-panel-progress .mission-progress-track {
  margin-top: 12px;
  height: 10px;
}

.mission-panel-progress p {
  margin-top: 12px;
  color: #47524c;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.5;
}

.mission-start-button {
  display: grid;
  flex: 0 0 auto;
  min-height: 92px;
  align-content: center;
  gap: 7px;
  border: 0;
  border-radius: 0;
  background: #111714;
  color: #ffffff;
  padding: 16px 18px;
  text-align: left;
  transition: background-color 150ms ease, color 150ms ease;
}

.mission-start-button span {
  color: #ffffff;
  font-size: 21px;
  font-weight: 900;
  line-height: 1.2;
}

.mission-start-button strong {
  color: rgba(232, 244, 238, 0.82);
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
}

.mission-start-button:hover:not(:disabled) {
  background: #153126;
}

.mission-start-button:disabled {
  cursor: not-allowed;
  background: #d9dedb;
  color: #65706a;
}

.mission-start-button:disabled span,
.mission-start-button:disabled strong {
  color: #65706a;
}

.mission-start-button.is-retry {
  background: #9a6a12;
}

.mission-start-button.is-complete {
  background: #1f5f8b;
}

.mission-panel-switcher {
  margin-top: auto;
}

.mission-panel-switcher summary {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  list-style: none;
}

.mission-panel-switcher summary::-webkit-details-marker {
  display: none;
}

.mission-panel-switcher summary span {
  color: #65706a;
  font-size: 11px;
  font-weight: 900;
}

.mission-panel-switcher summary strong {
  color: #111714;
  font-size: 12px;
  font-weight: 900;
}

.mission-switcher-list {
  display: grid;
  gap: 6px;
  margin-top: 12px;
}

.mission-switcher-list button {
  display: grid;
  gap: 3px;
  min-height: 50px;
  border: 1px solid #d9dedb;
  border-radius: 8px;
  background: #ffffff;
  color: #111714;
  padding: 8px 9px;
  text-align: left;
}

.mission-switcher-list button.is-selected {
  border-color: #111714;
  background: #111714;
  color: #ffffff;
}

.mission-switcher-list span,
.mission-switcher-list em {
  overflow: hidden;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-switcher-list strong {
  overflow: hidden;
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-selection-screen {
  height: 100%;
  min-height: calc(100vh - var(--ops-topbar-height));
  overflow: auto;
  background: #eef1ef;
  color: #111714;
  padding: 22px;
}

.mission-selection-header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  margin: 0 auto;
  max-width: 1180px;
  padding: 2px 0 16px;
}

.mission-selection-title {
  min-width: 0;
}

.mission-selection-title p {
  color: #65706a;
}

.mission-selection-title h1 {
  margin-top: 7px;
  color: #111714;
  font-size: 28px;
  font-weight: 900;
  line-height: 1.18;
}

.mission-selection-summary {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  gap: 12px;
  border: 1px solid #d9dedb;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 14px;
  color: #47524c;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.05);
}

.mission-selection-summary span {
  font-size: 12px;
  font-weight: 900;
}

.mission-selection-summary strong {
  color: #111714;
  font-size: 18px;
  font-weight: 900;
}

.mission-list-board {
  display: grid;
  gap: 6px;
  margin: 0 auto;
  max-width: 1180px;
}

.mission-list-head,
.mission-list-row {
  display: grid;
  grid-template-columns: minmax(260px, 1.55fr) minmax(120px, 0.8fr) minmax(150px, 0.9fr) minmax(120px, 0.75fr) minmax(130px, 0.8fr) 88px;
  align-items: center;
  gap: 14px;
}

.mission-list-head {
  min-height: 34px;
  padding: 0 16px;
  color: #65706a;
}

.mission-list-head span {
  overflow: hidden;
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-list-row {
  width: 100%;
  min-height: 86px;
  border: 1px solid #d9dedb;
  border-radius: 8px;
  background: #ffffff;
  color: #111714;
  cursor: pointer;
  font-family: inherit;
  padding: 12px 16px;
  text-align: left;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.06);
  transition: border-color 150ms ease, background-color 150ms ease, transform 150ms ease, box-shadow 150ms ease;
}

.mission-list-row:hover:not(:disabled) {
  border-color: #7bc3a5;
  background: #fbfdfc;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.09);
  transform: translateY(-1px);
}

.mission-list-row:disabled {
  cursor: not-allowed;
  opacity: 0.64;
}

.mission-list-route,
.mission-list-cell {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.mission-list-route strong,
.mission-list-cell strong {
  overflow: hidden;
  color: #111714;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.28;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-list-route em,
.mission-list-cell span {
  overflow: hidden;
  color: #65706a;
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mission-list-status {
  display: inline-flex;
  width: fit-content;
  min-height: 25px;
  align-items: center;
  border-radius: 999px;
  padding: 0 10px;
  font-size: 11px !important;
  line-height: 1;
}

.mission-list-status.is-complete {
  background: #e8f4ee;
  color: #1f7a4d;
}

.mission-list-status.is-running,
.mission-list-status.is-upload {
  background: #e7f2f8;
  color: #1f5f8b;
}

.mission-list-status.is-retry {
  background: #fbf4df;
  color: #9a6a12;
}

.mission-list-status.is-waiting {
  background: #eef1ef;
  color: #47524c;
}

.mission-list-status.is-work-patrol-setup-required,
.mission-list-status.is-work-recapture-requested {
  background: #fffbeb;
  color: #92400e;
}

.mission-list-status.is-work-patrol-scheduled {
  background: #f7faf8;
  color: #46534c;
}

.mission-list-status.is-work-patrol-running {
  background: #f0f9ff;
  color: #0369a1;
}

.mission-list-status.is-work-patrol-completed {
  background: #f0fdfa;
  color: #0f766e;
}

.mission-list-status.is-work-ai-required {
  background: #eff6ff;
  color: #1d4ed8;
}

.mission-list-status.is-work-field-check-required {
  background: #fff1f2;
  color: #be123c;
}

.mission-list-status.is-work-report-required {
  background: #ecfeff;
  color: #0e7490;
}

.mission-list-status.is-work-report-generated {
  background: #f0fdf4;
  color: #15803d;
}

.mission-list-open {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #111714;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
}

.mission-empty-screen {
  display: grid;
  min-height: calc(100vh - var(--ops-topbar-height));
  align-content: center;
  justify-items: center;
  gap: 12px;
  background: #f3f5f4;
  color: #111714;
  padding: 24px;
  text-align: center;
}

.mission-empty-screen p {
  color: #65706a;
}

.mission-empty-screen h1 {
  color: #111714;
  font-size: 26px;
  font-weight: 900;
  line-height: 1.25;
}

.mission-empty-screen a {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #111714;
  color: #ffffff;
  padding: 0 16px;
  font-size: 13px;
  font-weight: 900;
  text-decoration: none;
}

@media (max-width: 1180px) {
  :host {
    height: 100%;
  }
  .mission-control-screen {
    overflow: auto;
    background: #eef1ef;
  }
  .mission-map-plane {
    min-height: 720px;
    margin-right: 0;
  }
  .mission-control-panel {
    position: relative;
    top: auto;
    right: auto;
    bottom: auto;
    width: auto;
    margin: 12px;
    box-shadow: 0 16px 34px rgba(15, 23, 42, 0.14);
  }
  .mission-selection-screen {
    padding: 18px;
  }
  .mission-list-head {
    display: none;
  }
  .mission-list-row {
    grid-template-columns: repeat(2, minmax(0, 1fr)) 96px;
    gap: 12px;
    min-height: 0;
  }
  .mission-list-route {
    grid-column: 1/-1;
  }
}
@media (max-width: 760px) {
  .mission-selection-screen {
    padding: 12px;
  }
  .mission-selection-header {
    display: grid;
    align-items: start;
    gap: 12px;
  }
  .mission-selection-title h1 {
    font-size: 24px;
  }
  .mission-selection-summary {
    justify-content: space-between;
    width: 100%;
  }
  .mission-list-row {
    grid-template-columns: 1fr;
    padding: 14px;
  }
  .mission-list-open {
    width: 100%;
  }
  .mission-map-plane {
    min-height: 760px;
  }
  .mission-map-header {
    grid-template-columns: 38px minmax(0, 1fr);
    right: 12px;
    left: 12px;
    top: 12px;
  }
  .mission-back-button {
    width: 38px;
    height: 38px;
  }
  .mission-map-title h1 {
    font-size: 26px;
  }
  .mission-map-meta {
    grid-column: 1/-1;
    justify-content: flex-start;
  }
  .mission-live-status {
    top: 148px;
    left: 12px;
    right: 12px;
    min-width: 0;
  }
  .mission-map-telemetry {
    left: 12px;
    right: 12px;
    bottom: 190px;
    grid-template-columns: 1fr;
  }
  .mission-bottom-dock {
    left: 12px;
    right: 12px;
    bottom: 12px;
    grid-template-columns: 1fr;
  }
  .mission-dock-panel:nth-child(n+3) {
    display: none;
  }
  .mission-point-row,
  .mission-source-ledger div,
  .mission-log-ledger div {
    grid-template-columns: 48px minmax(0, 1fr) 70px;
  }
  .mission-point-row em {
    display: none;
  }
  .mission-control-panel {
    margin: 8px;
  }
  .mission-progress-number {
    font-size: 44px;
  }
}`],
})
export class PageMissionsComponent implements OnInit {
    public selectedMissionCode: string = '';
    public patrolMissions: any[] = [];
    public setupTasks: any[] = [];
    public loadMessage: string = '';
    public uploading: boolean = false;
    public autoRunning: boolean = false;
    private activeRunToken: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.service.auth.allow('/access');
        await this.loadMissions();
    }

    public async loadMissions() {
        this.loadMessage = '';
        try {
            const response: any = await wiz.call('load', {}, { timeout: 15000 });
            const { code, data } = response || {};
            if (code === 200 && data) {
                this.patrolMissions = (data.missions || []).map((mission) => this.normalizeMission(mission));
                this.applyStoredCompletions();
                this.setupTasks = data.setupTasks || [];
                const requestParams = this.missionRequestParams();
                const hasMissionRequest = this.hasMissionRequest(requestParams);
                const requestedMission = hasMissionRequest ? this.requestedMission(this.patrolMissions, requestParams) : null;
                if (requestedMission) {
                    this.selectedMissionCode = requestedMission.code || '';
                } else if (hasMissionRequest) {
                    this.selectedMissionCode = '';
                    this.loadMessage = '선택한 순찰 기준은 현재 실행 대상으로 배포되어 있지 않습니다. 기준 화면에서 배포 상태를 확인하세요.';
                } else if (!this.patrolMissions.find((mission) => mission.code === this.selectedMissionCode)) {
                    this.selectedMissionCode = '';
                }
            } else {
                this.loadMessage = (data && data.message) || '순찰 실행 대상을 불러오지 못했습니다.';
            }
        } catch (error) {
            this.loadMessage = '순찰 실행 대상을 불러오는 중 오류가 발생했습니다.';
        }
        await this.service.render();
    }

    private normalizeMission(mission: any) {
        const item = mission || {};
        item.stage = this.normalizeStage(item.stage);
        item.drone = this.normalizeDrone(item.drone || {});
        item.preflight = this.normalizePreflight(item.preflight || []);
        item.points = this.normalizePoints(item.points || []);
        item.upload = this.normalizeUpload(item.upload || {}, item.stage, item.points.length);
        item.map = item.map || {};
        item.sourceReview = item.sourceReview || [];
        item.sourceType = this.sourceKey(item);
        item.sourceLabel = this.sourceLabel(item);
        item.status = item.status || (item.stage === 'completed' ? workflowStatusLabel('ai') : workflowStatusLabel('assigned'));
        item.due = item.due || (item.stage === 'completed' ? '업로드 완료' : '시작 전');
        item.currentFlowKey = item.currentFlowKey || (item.stage === 'completed' ? 'ai' : 'ready');
        item.summary = item.summary || `관측 지점 ${item.points.length}개`;
        item.nextPointLabel = item.nextPointLabel || this.nextPointLabel(item);
        if (item.stage === 'completed') {
            this.applyCompletedMission(item, null, false);
        }
        return item;
    }

    private sourceKey(item: any) {
        const value = (item && (item.sourceType || item.scenarioType) || '').toString().toLowerCase();
        if (value === 'demo' || value === 'sample' || value === 'example' || value === 'default') return 'demo';
        return 'custom';
    }

    public sourceLabel(item: any) {
        return this.sourceKey(item) === 'demo' ? '운영 기준' : '등록 기준';
    }

    private requestedMission(missions: any[], params: any) {
        return (missions || []).find((mission) => this.matchesMissionRequest(mission, params)) || null;
    }

    private missionRequestParams() {
        const query = new URLSearchParams((window && window.location && window.location.search) || '');
        return {
            mission: query.get('mission') || query.get('code') || '',
            missionCode: query.get('missionCode') || '',
            templateId: query.get('templateId') || ''
        };
    }

    private hasMissionRequest(params: any) {
        return !!(params && (params.mission || params.missionCode || params.templateId));
    }

    private normalizeMissionToken(value: any) {
        return String(value || '').trim().replace(/^MIS-/, '');
    }

    private matchesMissionRequest(mission: any, params: any) {
        const code = String(mission && mission.code || '');
        const missionCode = String(mission && mission.missionCode || '');
        const templateId = String(mission && mission.templateId || '');
        const requestedMission = String(params.mission || '');
        const requestedMissionToken = this.normalizeMissionToken(requestedMission);
        return !!(
            (params.templateId && templateId === params.templateId)
            || (params.missionCode && missionCode === params.missionCode)
            || (requestedMission && code === requestedMission)
            || (requestedMissionToken && this.normalizeMissionToken(code) === requestedMissionToken)
            || (requestedMissionToken && missionCode === requestedMissionToken)
        );
    }

    public sourceBadgeClass(item: any, activeSurface: boolean = false) {
        if (activeSurface) return 'border-white/30 bg-white/15 text-white';
        return this.sourceKey(item) === 'demo'
            ? 'border-amber-200 bg-amber-50 text-amber-800'
            : 'border-sky-200 bg-sky-50 text-sky-700';
    }

    private normalizeStage(stage: string) {
        const value = String(stage || 'assigned').toLowerCase();
        if (['assigned', 'drone', 'preflight', 'capture', 'upload', 'completed'].indexOf(value) >= 0) return value;
        return 'assigned';
    }

    private normalizeDrone(drone: any) {
        const flightAllowed = drone.flightAllowed !== false;
        return {
            name: drone.name || drone.droneName || '현장 배정 기체',
            battery: drone.battery || '92% / 예비 1팩',
            gps: drone.gps || 'RTK FIX',
            storage: drone.storage || '여유 48GB',
            weather: drone.weather || '시정 양호, 강수 없음',
            wind: drone.wind || '3.4m/s',
            flightAllowed: flightAllowed,
            flightLabel: drone.flightLabel || (flightAllowed ? '비행 승인 완료' : '비행 보류'),
            flightMessage: drone.flightMessage || (flightAllowed ? '비행 가능' : '현장 조건 확인')
        };
    }

    private normalizePreflight(preflight: any[]) {
        const defaults = [
            '배터리 확인',
            'GPS 고정 확인',
            '촬영 용량 확인',
            '기상 조건 확인',
            '비행 승인 확인',
            '이륙 지점 확인'
        ];
        const incoming = Array.isArray(preflight) ? preflight : [];
        return defaults.map((label) => {
            const found = incoming.find((item) => item && String(item.label || '').indexOf(label.replace(' 확인', '')) >= 0);
            return { label: label, checked: found && typeof found.checked === 'boolean' ? found.checked : true };
        });
    }

    private normalizePoints(points: any[]) {
        return (Array.isArray(points) ? points : []).map((point, index) => {
            const status = this.normalizePointStatus(point.status);
            return {
                code: point.code || `P-${String(index + 1).padStart(2, '0')}`,
                name: point.name || `관측 지점 ${index + 1}`,
                coord: point.coord || '',
                mapX: Number(point.mapX || (22 + index * 10)),
                mapY: Number(point.mapY || Math.max(18, 70 - index * 7)),
                altitude: point.altitude || '기준 고도 미지정',
                heading: point.heading || '기준 방향 미지정',
                gimbal: point.gimbal || '짐벌 기준 미지정',
                zoom: point.zoom || '줌 기준 미지정',
                required: point.required !== false,
                status: status,
                statusText: this.pointStatusText({ status: status }),
                note: point.note || (status === 'done' ? '촬영 완료' : '자동 촬영 대기'),
                photos: point.photos || '',
                baselineState: point.baselineState || '기준 사진 확인',
                currentResult: point.currentResult || '현재 촬영 대기'
            };
        });
    }

    private normalizePointStatus(status: string) {
        const value = String(status || 'pending').toLowerCase();
        if (['done', 'completed', 'complete', '촬영 완료', '완료'].indexOf(value) >= 0) return 'done';
        if (['moving', 'move', '이동 중'].indexOf(value) >= 0) return 'moving';
        if (['capturing', 'capture', '촬영 중'].indexOf(value) >= 0) return 'capturing';
        if (['retake', 'recapture', 'needs_retake', 'blocked', 'inaccessible', '재촬영 필요', '접근 불가'].indexOf(value) >= 0) return 'retake';
        return 'pending';
    }

    private normalizeUpload(upload: any, stage: string, pointCount: number) {
        const completed = stage === 'completed';
        const photoCount = Math.max(1, pointCount) * 2;
        return {
            progress: completed ? 100 : Number(upload.progress || 0),
            status: upload.status || (completed ? workflowStatusLabel('ai') : workflowStatusLabel('patrolRunning')),
            message: upload.message || (completed ? `업로드 완료 · ${workflowStatusLabel('ai')}` : '촬영 후 업로드 대기'),
            exception: upload.exception || '통신 불안정 시 안정 구간에서 촬영자료를 재전송합니다.',
            tempSaved: typeof upload.tempSaved === 'boolean' ? upload.tempSaved : !completed,
            networkMessage: upload.networkMessage || '전송 준비 완료 · 재시도 가능',
            complete: typeof upload.complete === 'boolean' ? upload.complete : completed,
            retryable: !!upload.retryable,
            aiStatus: upload.aiStatus || (completed ? workflowStatusLabel('ai') : '업로드 완료 후 AI 확인 필요'),
            steps: upload.steps || [
                { label: completed ? '촬영 완료' : '촬영 예정', value: `${photoCount}장` },
                { label: '업로드', value: completed ? '완료' : '대기' },
                { label: 'AI 확인', value: completed ? '확인 필요' : '업로드 후 확인' }
            ]
        };
    }

    public get todayMission() {
        return {
            date: this.todayLabel(),
            shift: this.patrolMissions.length ? '자동 순찰 실행' : '순찰 기준 배포 필요',
            readyLabel: `배정 ${this.patrolMissions.length}건`
        };
    }

    public todayLabel() {
        const now = new Date();
        const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day} ${dayNames[now.getDay()]}`;
    }

    private completionStorageKey() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `songnisan.missions.completed.${year}-${month}-${day}`;
    }

    private completedMissionMap() {
        try {
            return JSON.parse(localStorage.getItem(this.completionStorageKey()) || '{}') || {};
        } catch (error) {
            return {};
        }
    }

    private rememberCompletedMission(mission: any, caseCount: number = 0) {
        if (!mission || !mission.code) return;
        try {
            const map = this.completedMissionMap();
            map[mission.code] = {
                caseCount: caseCount,
                completedAt: new Date().toISOString()
            };
            localStorage.setItem(this.completionStorageKey(), JSON.stringify(map));
        } catch (error) { }
    }

    private forgetCompletedMission(mission: any) {
        if (!mission || !mission.code) return;
        try {
            const map = this.completedMissionMap();
            delete map[mission.code];
            localStorage.setItem(this.completionStorageKey(), JSON.stringify(map));
        } catch (error) { }
    }

    private applyStoredCompletions() {
        const map = this.completedMissionMap();
        this.patrolMissions.forEach((mission) => {
            const stored = map[mission.code];
            const storedCaseCount = Number(stored && stored.caseCount || 0);
            if (stored && storedCaseCount <= 0) {
                this.forgetCompletedMission(mission);
                return;
            }
            if (stored && mission.stage !== 'completed') {
                this.applyCompletedMission(mission, storedCaseCount, false);
            }
        });
    }

    private applyCompletedMission(mission: any, caseCount: any = null, updateStorage: boolean = true) {
        if (!mission) return;
        const totalPoints = mission.points ? mission.points.length : 0;
        const photoCount = totalPoints * 2;
        mission.stage = 'completed';
        mission.status = workflowStatusLabel('ai');
        mission.due = '업로드 완료';
        mission.currentFlowKey = 'ai';
        mission.nextPointLabel = workflowStatusLabel('ai');
        if (mission.preflight) mission.preflight.forEach((item) => item.checked = true);
        if (mission.points) {
            mission.points.forEach((point) => {
                point.status = 'done';
                point.statusText = '촬영 완료';
                point.photos = point.photos || '2장';
                point.note = '기준값 자동 촬영 완료';
            });
        }
        if (mission.upload) {
            mission.upload.progress = 100;
            mission.upload.status = workflowStatusLabel('ai');
            mission.upload.message = caseCount === null
                ? '업로드 완료 상태입니다. AI 확인 항목 반영 결과를 확인 중입니다.'
                : `업로드 완료, AI 확인 항목 ${caseCount}건이 반영되었습니다.`;
            mission.upload.tempSaved = false;
            mission.upload.complete = true;
            mission.upload.retryable = false;
            mission.upload.aiStatus = caseCount === null ? workflowStatusLabel('ai') : `${workflowStatusLabel('ai')} ${caseCount}건`;
            mission.upload.steps = [
                { label: '촬영 완료', value: `${photoCount}장` },
                { label: '업로드', value: '완료' },
                { label: 'AI 확인', value: caseCount === null ? '확인 필요' : `${caseCount}건` }
            ];
        }
        if (updateStorage && caseCount !== null) this.rememberCompletedMission(mission, Number(caseCount || 0));
    }

    private applyUploadRetryState(mission: any, message: string) {
        if (!mission) return;
        const totalPoints = mission.points ? mission.points.length : 0;
        const photoCount = totalPoints * 2;
        mission.stage = 'upload';
        mission.status = workflowStatusLabel('ai');
        mission.due = 'AI 확인 필요';
        mission.currentFlowKey = 'upload';
        mission.nextPointLabel = workflowStatusLabel('ai');
        if (mission.upload) {
            mission.upload.progress = 100;
            mission.upload.status = 'AI 확인 반영 보류';
            mission.upload.message = message;
            mission.upload.tempSaved = true;
            mission.upload.complete = false;
            mission.upload.retryable = true;
            mission.upload.aiStatus = 'AI 확인 반영 보류';
            mission.upload.steps = [
                { label: '촬영 완료', value: `${photoCount}장` },
                { label: '업로드', value: '재시도 필요' },
                { label: 'AI 확인', value: '반영 보류' }
            ];
        }
    }

    private responseData(response: any) {
        if (!response) return null;
        return response.data || response;
    }

    private responseMessage(response: any, fallback: string) {
        const data = this.responseData(response);
        return (data && data.message) || (response && response.message) || fallback;
    }

    private isCompletionResponse(response: any) {
        const code = response && response.code;
        const data = this.responseData(response);
        if (code !== 200 || !data) return false;
        return typeof data.caseCount !== 'undefined' || !!data.missionRun || Array.isArray(data.cases);
    }

    private completionCaseCount(responseOrData: any) {
        const data = this.responseData(responseOrData);
        if (!data) return 0;
        if (typeof data.caseCount !== 'undefined') return Number(data.caseCount || 0);
        if (Array.isArray(data.cases)) return data.cases.length;
        return 0;
    }

    private completionPayload(mission: any) {
        return {
            code: mission.code || '',
            missionCode: mission.missionCode || '',
            templateId: mission.templateId || '',
            village: mission.village || '',
            operator: mission.operator || '',
            sourceType: this.sourceKey(mission),
            sourceLabel: this.sourceLabel(mission),
            points: (mission.points || []).map((point) => ({
                code: point.code || '',
                name: point.name || '',
                status: point.status || '',
                photos: point.photos || '',
                note: point.note || ''
            }))
        };
    }

    private async requestMissionCompletion(mission: any) {
        const payload = { mission: JSON.stringify(this.completionPayload(mission)) };
        let response: any = null;
        let firstResponse: any = null;
        try {
            response = await wiz.call('load', {
                action: 'complete',
                ...payload
            }, { timeout: 15000 });
            if (this.isCompletionResponse(response)) return response;
            firstResponse = response;
        } catch (error) { }
        try {
            response = await wiz.call('complete', payload, { timeout: 15000 });
            if (this.isCompletionResponse(response)) return response;
        } catch (error) { }
        return response || firstResponse;
    }

    public get activeMission() {
        return this.patrolMissions.find((item) => item.code === this.selectedMissionCode) || null;
    }

    public get hasMissions() {
        return this.patrolMissions.length > 0;
    }

    public missionPointCount(mission: any) {
        return mission && Array.isArray(mission.points) ? mission.points.filter((point) => point.required !== false).length : 0;
    }

    public missionListStatusClass(mission: any) {
        return workflowStatusCssClass(this.missionWorkflowStatusKey(mission));
    }

    public get requiredPoints() {
        if (!this.activeMission) return [];
        return this.activeMission.points.filter((item) => item.required !== false);
    }

    public get completedPoints() {
        return this.requiredPoints.filter((item) => item.status === 'done').length;
    }

    public get requiredPointCount() {
        return this.requiredPoints.length;
    }

    public get allRequiredPointsComplete() {
        return this.requiredPointCount > 0 && this.completedPoints === this.requiredPointCount;
    }

    public get captureProgress() {
        if (!this.requiredPointCount) return 0;
        return Math.round((this.completedPoints / this.requiredPointCount) * 100);
    }

    public get currentPoint() {
        if (!this.activeMission) return null;
        const points = this.activeMission.points || [];
        return points.find((item) => item.status === 'moving' || item.status === 'capturing')
            || points.find((item) => item.required !== false && item.status === 'pending')
            || points.find((item) => item.required !== false && item.status === 'retake')
            || null;
    }

    public get canShowUpload() {
        return !!this.activeMission && (this.activeMission.stage === 'upload' || this.activeMission.stage === 'completed');
    }

    public get showPostPatrolActions() {
        if (!this.activeMission) return false;
        return this.activeMission.stage === 'completed' || (this.activeMission.stage === 'upload' && this.activeMission.upload.retryable);
    }

    public get showManualIntervention() {
        return !!this.activeMission && this.activeMission.stage === 'capture' && !this.autoRunning;
    }

    private expectedMinutes(mission: any) {
        const match = String(mission && mission.expectedTime || '').match(/\d+/);
        if (match) return Number(match[0]);
        return Math.max(30, ((mission && mission.points ? mission.points.length : 0) * 8) + 20);
    }

    public expectedReturnTime(mission: any = this.activeMission) {
        if (!mission) return '-';
        const minutes = this.expectedMinutes(mission);
        const date = new Date(Date.now() + minutes * 60000);
        const hours = String(date.getHours()).padStart(2, '0');
        const mins = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${mins} 예상`;
    }

    public get missionStats() {
        if (!this.activeMission) return [];
        return [
            { label: '선택된 순찰 기준', value: this.activeMission.routeName || '순찰 기준 미지정', detail: this.activeMission.village || '-', tone: 'default' },
            { label: '사용 드론', value: this.activeMission.drone.name, detail: this.activeMission.drone.flightLabel, tone: 'default' },
            { label: '총 관측 지점 수', value: `${this.requiredPointCount}개`, detail: '순찰 기준에서 불러옴', tone: 'default' },
            { label: '예상 비행 시간', value: this.activeMission.expectedTime || `${this.expectedMinutes(this.activeMission)}분`, detail: '이륙부터 복귀까지', tone: 'default' },
            { label: '예상 복귀 시간', value: this.expectedReturnTime(this.activeMission), detail: this.activeMission.launch || '이륙 지점 미지정', tone: 'default' },
            { label: '임무 상태', value: this.missionStageLabel(this.activeMission), detail: this.activeMission.due || '-', tone: 'status' }
        ];
    }

    public mapTileUrl(mission: any = this.activeMission) {
        return mission && mission.map && mission.map.tileUrl ? mission.map.tileUrl : '';
    }

    public mapAttribution(mission: any = this.activeMission) {
        return mission && mission.map && mission.map.attribution ? mission.map.attribution : 'Open map background';
    }

    public mapSourceNote(mission: any = this.activeMission) {
        return mission && mission.map && mission.map.sourceNote ? mission.map.sourceNote : '지도 배경은 위치 이해용입니다.';
    }

    public mapTerrainNote(mission: any = this.activeMission) {
        return mission && mission.map && mission.map.terrainNote ? mission.map.terrainNote : '관측 포인트와 자동 비행 경로를 지도형 배경 위에 표시합니다.';
    }

    private clampMapValue(value: any, fallback: number) {
        const numeric = Number(value);
        if (!isFinite(numeric)) return fallback;
        return Math.max(4, Math.min(96, numeric));
    }

    private launchCoord(mission: any = this.activeMission) {
        return {
            x: this.clampMapValue(mission && mission.launchMapX, 14),
            y: this.clampMapValue(mission && mission.launchMapY, 76)
        };
    }

    private pointCoord(point: any) {
        return {
            x: this.clampMapValue(point && point.mapX, 50),
            y: this.clampMapValue(point && point.mapY, 50)
        };
    }

    private coordText(coord: any) {
        return `${coord.x},${coord.y}`;
    }

    private routeCoords(mission: any = this.activeMission) {
        if (!mission) return [];
        return [this.launchCoord(mission)]
            .concat((mission.points || []).map((point) => this.pointCoord(point)))
            .concat([this.launchCoord(mission)]);
    }

    public mapPathPoints(mission: any = this.activeMission) {
        return this.routeCoords(mission).map((coord) => this.coordText(coord)).join(' ');
    }

    public mapCompletedPathPoints(mission: any = this.activeMission) {
        if (!mission) return '';
        const coords = [this.launchCoord(mission)];
        const points = mission.points || [];
        for (const point of points) {
            if (point.status !== 'done') break;
            coords.push(this.pointCoord(point));
        }
        if ((mission.stage === 'upload' || mission.stage === 'completed') && points.length && points.every((point) => point.status === 'done')) {
            coords.push(this.launchCoord(mission));
        }
        return coords.map((coord) => this.coordText(coord)).join(' ');
    }

    private flowPoint(mission: any = this.activeMission) {
        if (!mission) return null;
        const key = String(mission.currentFlowKey || '');
        if (key.indexOf('move-') !== 0 && key.indexOf('capture-') !== 0) return null;
        const code = key.replace(/^move-/, '').replace(/^capture-/, '');
        return (mission.points || []).find((point) => point.code === code) || null;
    }

    private previousRouteCoord(mission: any, point: any) {
        const points = mission && mission.points ? mission.points : [];
        const index = points.findIndex((item) => item.code === point?.code);
        if (index <= 0) return this.launchCoord(mission);
        return this.pointCoord(points[index - 1]);
    }

    private interpolateCoord(from: any, to: any, ratio: number) {
        return {
            x: Math.round((from.x + ((to.x - from.x) * ratio)) * 10) / 10,
            y: Math.round((from.y + ((to.y - from.y) * ratio)) * 10) / 10
        };
    }

    private droneCoord(mission: any = this.activeMission) {
        if (!mission) return this.launchCoord(mission);
        const key = String(mission.currentFlowKey || '');
        const launch = this.launchCoord(mission);
        if (mission.stage === 'upload' || mission.stage === 'completed') return launch;
        if (key === 'takeoff' || !key || key === 'ready') return launch;
        if (key === 'return') {
            const points = mission.points || [];
            const lastDone = points.slice().reverse().find((point) => point.status === 'done') || points[points.length - 1];
            return lastDone ? this.interpolateCoord(this.pointCoord(lastDone), launch, 0.58) : launch;
        }
        const point = this.flowPoint(mission);
        if (!point) return launch;
        const target = this.pointCoord(point);
        if (key.indexOf('capture-') === 0) return target;
        return this.interpolateCoord(this.previousRouteCoord(mission, point), target, 0.68);
    }

    public mapActivePathPoints(mission: any = this.activeMission) {
        if (!mission || mission.stage === 'upload' || mission.stage === 'completed') return '';
        const key = String(mission.currentFlowKey || '');
        const drone = this.droneCoord(mission);
        if (key === 'return') {
            const points = mission.points || [];
            const lastDone = points.slice().reverse().find((point) => point.status === 'done') || points[points.length - 1];
            return lastDone ? [this.pointCoord(lastDone), drone].map((coord) => this.coordText(coord)).join(' ') : '';
        }
        const point = this.flowPoint(mission);
        if (!point) return '';
        const from = this.previousRouteCoord(mission, point);
        const to = key.indexOf('capture-') === 0 ? this.pointCoord(point) : drone;
        return [from, to].map((coord) => this.coordText(coord)).join(' ');
    }

    public mapPointStyle(point: any) {
        return {
            left: `${this.clampMapValue(point && point.mapX, 50)}%`,
            top: `${this.clampMapValue(point && point.mapY, 50)}%`
        };
    }

    public mapLaunchStyle(mission: any = this.activeMission) {
        const launch = this.launchCoord(mission);
        return {
            left: `${launch.x}%`,
            top: `${launch.y}%`
        };
    }

    public droneMapStyle(mission: any = this.activeMission) {
        const coord = this.droneCoord(mission);
        return {
            left: `${coord.x}%`,
            top: `${coord.y}%`
        };
    }

    public droneMapLabel(mission: any = this.activeMission) {
        if (!mission) return '대기';
        const key = String(mission.currentFlowKey || '');
        const point = this.flowPoint(mission);
        if (mission.stage === 'completed') return '복귀 완료';
        if (mission.stage === 'upload') return '업로드';
        if (key === 'takeoff') return '이륙';
        if (key === 'return') return '복귀';
        if (key.indexOf('move-') === 0 && point) return `${point.code} 이동`;
        if (key.indexOf('capture-') === 0 && point) return `${point.code} 촬영`;
        return '대기';
    }

    public droneMarkerClass(mission: any = this.activeMission) {
        if (!mission) return 'mission-drone-idle';
        const key = String(mission.currentFlowKey || '');
        if (mission.stage === 'completed') return 'mission-drone-complete';
        if (mission.stage === 'upload') return 'mission-drone-upload';
        if (key === 'return') return 'mission-drone-return';
        if (key.indexOf('capture-') === 0) return 'mission-drone-capture';
        if (key.indexOf('move-') === 0 || key === 'takeoff') return 'mission-drone-active';
        return 'mission-drone-idle';
    }

    public mapMarkerClass(point: any) {
        const classes = [];
        if (point.status === 'done') classes.push('mission-map-done');
        else if (point.status === 'moving' || point.status === 'capturing') classes.push('mission-map-current');
        else if (point.status === 'retake') classes.push('mission-map-retake');
        else classes.push('mission-map-pending');
        if (this.currentPoint && this.currentPoint.code === point.code) classes.push('mission-map-focus');
        return classes.join(' ');
    }

    private textLooksReady(value: string) {
        const text = String(value || '').trim();
        if (!text) return false;
        const blocked = ['미지정', '부족', '없음 확인', '대기', '보류', '불가', '실패', '경고'];
        return !blocked.some((word) => text.indexOf(word) >= 0);
    }

    private get launchReady() {
        if (!this.activeMission) return false;
        const launch = String(this.activeMission.launch || '');
        return !!launch && launch.indexOf('미지정') < 0;
    }

    public get readinessItems() {
        if (!this.activeMission) return [];
        const drone = this.activeMission.drone;
        return [
            { key: 'battery', label: '배터리', value: drone.battery, detail: '본체와 예비 배터리 확인', ready: this.textLooksReady(drone.battery) },
            { key: 'gps', label: 'GPS', value: drone.gps, detail: '자동 항로 비행 위치 고정', ready: this.textLooksReady(drone.gps) },
            { key: 'storage', label: '촬영 용량', value: drone.storage, detail: '지점별 촬영자료 기록 가능', ready: this.textLooksReady(drone.storage) },
            { key: 'weather', label: '기상 조건', value: drone.weather, detail: `풍속 ${drone.wind}`, ready: this.textLooksReady(drone.weather) && drone.flightAllowed !== false },
            { key: 'approval', label: '비행 승인', value: drone.flightLabel, detail: drone.flightMessage, ready: drone.flightAllowed !== false },
            { key: 'launch', label: '이륙 지점', value: this.activeMission.launch || '이륙 지점 미지정', detail: '자동 복귀 기준점 확인', ready: this.launchReady }
        ];
    }

    public get readinessCount() {
        return this.readinessItems.filter((item) => item.ready).length;
    }

    public get allReadinessReady() {
        return this.requiredPointCount > 0 && this.readinessItems.length > 0 && this.readinessItems.every((item) => item.ready);
    }

    public get readinessBlockedMessage() {
        if (!this.activeMission) return '순찰 기준을 선택해야 합니다.';
        if (!this.requiredPointCount) return '순찰 기준에 관측 지점이 없습니다.';
        const missing = this.readinessItems.filter((item) => !item.ready).map((item) => item.label);
        if (!missing.length) return '준비 완료';
        return `${missing.join(', ')} 점검 필요`;
    }

    private missionBaseFlowSteps(mission: any) {
        if (!mission) return [];
        const steps: any[] = [
            {
                key: 'takeoff',
                eyebrow: '이륙',
                label: '이륙',
                description: `${mission.launch || '이륙 지점'}에서 자동 순찰 임무를 시작합니다.`
            }
        ];
        (mission.points || []).forEach((point) => {
            steps.push({
                key: `move-${point.code}`,
                pointCode: point.code,
                eyebrow: point.code,
                label: `${point.code} 이동`,
                description: `${point.name} 관측 지점으로 자동 이동합니다.`
            });
            steps.push({
                key: `capture-${point.code}`,
                pointCode: point.code,
                eyebrow: point.code,
                label: `${point.code} 자동 촬영`,
                description: `고도 ${point.altitude}, 방향 ${point.heading}, 짐벌 ${point.gimbal}, 줌 ${point.zoom}`
            });
        });
        steps.push({
            key: 'return',
            eyebrow: '복귀',
            label: '복귀',
            description: `${mission.launch || '이륙 지점'}으로 자동 복귀합니다.`
        });
        steps.push({
            key: 'upload',
            eyebrow: '업로드',
            label: '촬영본 업로드',
            description: '모든 지점 촬영 완료 후 사진과 메타데이터를 업로드합니다.'
        });
        return steps;
    }

    private currentFlowIndex(steps: any[]) {
        if (!this.activeMission) return -1;
        if (this.activeMission.stage === 'completed') return steps.length;
        if (this.activeMission.stage === 'upload') return steps.findIndex((step) => step.key === 'upload');
        if (this.activeMission.stage === 'capture') return steps.findIndex((step) => step.key === this.activeMission.currentFlowKey);
        return -1;
    }

    public get missionFlowSteps() {
        const steps = this.missionBaseFlowSteps(this.activeMission);
        const currentIndex = this.currentFlowIndex(steps);
        return steps.map((step, index) => {
            let state = 'pending';
            if (this.activeMission && this.activeMission.stage === 'completed') state = 'done';
            else if (currentIndex >= 0 && index < currentIndex) state = 'done';
            else if (currentIndex >= 0 && index === currentIndex) state = 'current';
            return { ...step, state: state };
        });
    }

    public get missionProgress() {
        const steps = this.missionFlowSteps;
        if (!steps.length || !this.activeMission) return 0;
        if (this.activeMission.stage === 'completed') return 100;
        let units = 0;
        steps.forEach((step) => {
            if (step.state === 'done') units += 1;
            if (step.state === 'current') {
                units += step.key === 'upload' ? Math.max(0, Math.min(100, this.activeMission.upload.progress)) / 100 : 0.5;
            }
        });
        return Math.max(0, Math.min(100, Math.round((units / steps.length) * 100)));
    }

    public get currentRoutePointLabel() {
        if (!this.activeMission) return '-';
        if (this.activeMission.stage === 'completed') return workflowStatusLabel('ai');
        if (this.activeMission.stage === 'upload') return '업로드';
        if (this.activeMission.stage === 'capture') return this.activeMission.nextPointLabel || workflowStatusLabel('patrolRunning');
        return this.allReadinessReady ? '시작 가능' : '준비 확인';
    }

    public get remainingPointCount() {
        return this.requiredPoints.filter((point) => point.status !== 'done').length;
    }

    private pointOrder(point: any) {
        const index = this.requiredPoints.findIndex((item) => item.code === point?.code);
        return index >= 0 ? index + 1 : 0;
    }

    public get droneMovementSummary() {
        if (!this.activeMission) return '자동 순찰 없음';
        const mission = this.activeMission;
        const key = String(mission.currentFlowKey || '');
        const point = this.flowPoint(mission);
        if (mission.stage === 'completed') return `복귀 완료 · ${workflowStatusLabel('ai')}`;
        if (mission.stage === 'upload') return this.uploading ? '촬영본 업로드 중' : '업로드 대기';
        if (key === 'takeoff') return `${mission.launch || '이륙 지점'}에서 이륙 중`;
        if (key === 'return') return `${mission.launch || '이륙 지점'}으로 복귀 중`;
        if (key.indexOf('move-') === 0 && point) return `${point.code} ${point.name} 방향으로 이동 중`;
        if (key.indexOf('capture-') === 0 && point) return `${point.code} ${point.name} 상공에서 자동 촬영 중`;
        return workflowStatusLabel('assigned');
    }

    public get capturePointSummary() {
        if (!this.activeMission || !this.requiredPointCount) return '촬영 지점 없음';
        const mission = this.activeMission;
        const key = String(mission.currentFlowKey || '');
        const point = this.flowPoint(mission);
        if (key.indexOf('capture-') === 0 && point) return `${this.pointOrder(point)}번째 포인트 ${point.code} 촬영 중`;
        if (key.indexOf('move-') === 0 && point) return `다음 촬영 ${this.pointOrder(point)}번째 포인트 ${point.code}`;
        if (mission.stage === 'upload' || mission.stage === 'completed') return `촬영 완료 ${this.completedPoints}/${this.requiredPointCount}`;
        if (key === 'return') return '모든 포인트 촬영 후 복귀 중';
        return '촬영 대기';
    }

    public get remainingPointSummary() {
        if (!this.requiredPointCount) return '0개';
        return `${this.remainingPointCount}개 남음`;
    }

    public get mapSummaryCards() {
        return [
            { label: '현재 이동', value: this.droneMovementSummary, detail: this.droneMapLabel() },
            { label: '촬영 순서', value: this.capturePointSummary, detail: `완료 ${this.completedPoints}/${this.requiredPointCount}` },
            { label: '남은 포인트', value: this.remainingPointSummary, detail: this.remainingPointCount > 0 ? '촬영 대기 지점 포함' : '복귀·업로드 단계' }
        ];
    }

    public get mapStatusLegend() {
        return [
            { label: '완료', className: 'mission-map-legend-done' },
            { label: '이동/촬영', className: 'mission-map-legend-current' },
            { label: '재촬영 필요', className: 'mission-map-legend-retake' },
            { label: '대기', className: 'mission-map-legend-pending' }
        ];
    }

    public get commandPhase() {
        if (!this.activeMission) return 'empty';
        if (this.autoRunning || this.activeMission.stage === 'capture') return 'capture';
        if (this.uploading) return 'uploading';
        if (this.activeMission.stage === 'completed') return 'ai';
        if (this.activeMission.stage === 'upload') return this.activeMission.upload.retryable ? 'retry' : 'upload';
        return this.allReadinessReady ? 'ready' : 'blocked';
    }

    public get commandPhaseLabel() {
        if (this.commandPhase === 'ready') return workflowStatusLabel('assigned');
        if (this.commandPhase === 'capture') return workflowStatusLabel('patrolRunning');
        if (this.commandPhase === 'ai') return workflowStatusLabel('ai');
        if (this.commandPhase === 'retry') return workflowStatusLabel('ai');
        if (this.commandPhase === 'upload' || this.commandPhase === 'uploading') return workflowStatusLabel('patrolRunning');
        if (this.commandPhase === 'blocked') return workflowStatusLabel('setup');
        return workflowStatusLabel('assigned');
    }

    public get operationSteps() {
        const phase = this.commandPhase;
        return [
            {
                order: '1',
                label: workflowStatusLabel('assigned'),
                state: ['capture', 'upload', 'uploading', 'retry', 'ai'].indexOf(phase) >= 0 ? 'done' : (phase === 'ready' ? 'current' : 'pending')
            },
            {
                order: '2',
                label: workflowStatusLabel('patrolRunning'),
                state: ['upload', 'uploading', 'retry', 'ai'].indexOf(phase) >= 0 ? 'done' : (phase === 'capture' ? 'current' : 'pending')
            },
            {
                order: '3',
                label: workflowStatusLabel('ai'),
                state: phase === 'ai' ? 'current' : 'pending'
            }
        ];
    }

    public get currentOperationTitle() {
        if (!this.activeMission) return '자동 순찰 없음';
        if (this.commandPhase === 'ready') return workflowStatusLabel('assigned');
        if (this.commandPhase === 'capture') return workflowStatusLabel('patrolRunning');
        if (this.commandPhase === 'ai') return workflowStatusLabel('ai');
        if (this.commandPhase === 'retry') return '업로드 재시도 필요';
        if (this.commandPhase === 'upload' || this.commandPhase === 'uploading') return '촬영본 업로드';
        return '준비 확인';
    }

    public get currentOperationDescription() {
        if (!this.activeMission) return '배포 기준 없음';
        if (this.commandPhase === 'ready') return `경로 ${this.requiredPointCount}지점과 드론 상태가 준비되었습니다.`;
        if (this.commandPhase === 'capture') return this.currentRoutePointLabel;
        if (this.commandPhase === 'ai') return this.activeMission.upload.aiStatus || '촬영 결과 확인 화면으로 이동할 수 있습니다.';
        if (this.commandPhase === 'retry' || this.commandPhase === 'upload') return this.activeMission.upload.message;
        if (this.commandPhase === 'uploading') return '촬영본을 업로드하고 있습니다.';
        return this.readinessBlockedMessage;
    }

    public get primaryActionLabel() {
        if (!this.activeMission) return '자동 순찰 없음';
        if (this.autoRunning) return '촬영 진행 중';
        if (this.uploading) return '촬영본 업로드 중';
        if (this.activeMission.stage === 'completed') return workflowStatusLabel('ai');
        if (this.activeMission.stage === 'upload' && this.activeMission.upload.retryable) return '업로드 재시도';
        return '자동 순찰 시작';
    }

    public get primaryActionHint() {
        if (!this.activeMission) return '순찰 기준 필요';
        if (this.activeMission.stage === 'completed') return '촬영 결과 확인';
        if (this.autoRunning) return this.capturePointSummary;
        if (this.uploading) return 'AI 확인 항목 반영 중';
        if (this.activeMission.stage === 'upload' && this.activeMission.upload.retryable) return '재시도 가능';
        if (this.allReadinessReady) return '이륙, 촬영, 복귀를 한 번에 실행';
        return this.readinessBlockedMessage;
    }

    public get primaryActionDisabled() {
        if (!this.activeMission || this.autoRunning || this.uploading) return true;
        if (this.activeMission.stage === 'completed') return false;
        if (this.activeMission.stage === 'upload') return !this.activeMission.upload.retryable;
        return !this.allReadinessReady;
    }

    private updateMissionRequestQuery(code: string = '') {
        try {
            if (typeof window === 'undefined' || !window.history || !window.location) return;
            const url = new URL(window.location.href);
            url.searchParams.delete('code');
            url.searchParams.delete('missionCode');
            url.searchParams.delete('templateId');
            if (code) url.searchParams.set('mission', code);
            else url.searchParams.delete('mission');
            window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        } catch (error) { }
    }

    public async showMissionList() {
        if (this.autoRunning || this.uploading) return;
        this.selectedMissionCode = '';
        this.loadMessage = '';
        this.updateMissionRequestQuery('');
        await this.service.render();
    }

    public async selectMission(code: string) {
        if (this.autoRunning || this.uploading) return;
        const mission = this.patrolMissions.find((item) => item.code === code);
        if (!mission) return;
        this.selectedMissionCode = mission.code || '';
        this.loadMessage = '';
        this.updateMissionRequestQuery(this.selectedMissionCode);
        await this.service.render();
    }

    public async runPrimaryAction() {
        if (this.primaryActionDisabled || !this.activeMission) return;
        if (this.activeMission.stage === 'completed') {
            const params = new URLSearchParams();
            if (this.activeMission.code) params.set('mission', this.activeMission.code);
            if (this.activeMission.missionCode) params.set('missionCode', this.activeMission.missionCode);
            if (this.activeMission.templateId) params.set('templateId', this.activeMission.templateId);
            const query = params.toString();
            this.service.href(query ? `/ai-review?${query}` : '/ai-review');
            return;
        }
        if (this.activeMission.stage === 'upload' && this.activeMission.upload.retryable) {
            await this.startUpload();
            return;
        }
        await this.startAutoPatrol();
    }

    private resetMissionForAutoRun(mission: any) {
        this.forgetCompletedMission(mission);
        mission.stage = 'capture';
        mission.status = workflowStatusLabel('patrolRunning');
        mission.due = '이륙 준비';
        mission.currentFlowKey = 'takeoff';
        mission.nextPointLabel = '이륙 중';
        (mission.points || []).forEach((point) => {
            point.status = 'pending';
            point.statusText = '대기';
            point.photos = '';
            point.note = '자동 촬영 대기';
        });
        mission.upload.progress = 0;
        mission.upload.status = '촬영 완료 후 업로드';
        mission.upload.message = '촬영 후 업로드 대기';
        mission.upload.tempSaved = true;
        mission.upload.complete = false;
        mission.upload.retryable = false;
        mission.upload.aiStatus = '업로드 완료 후 AI 확인 필요';
    }

    private async advanceFlow(mission: any, key: string, status: string, due: string, nextPointLabel: string, delay: number) {
        mission.currentFlowKey = key;
        mission.status = status;
        mission.due = due;
        mission.nextPointLabel = nextPointLabel;
        await this.service.render();
        await this.service.sleep(delay);
    }

    public async startAutoPatrol() {
        if (!this.activeMission || !this.allReadinessReady || this.autoRunning || this.uploading) return;
        const mission = this.activeMission;
        const token = `${mission.code}-${Date.now()}`;
        this.activeRunToken = token;
        this.autoRunning = true;
        // Prototype-only state progression; this does not send a flight command.
        this.resetMissionForAutoRun(mission);

        try {
            await this.advanceFlow(mission, 'takeoff', workflowStatusLabel('patrolRunning'), '자동 순찰 이륙', '이륙 중', 650);
            for (const point of mission.points || []) {
                if (this.activeRunToken !== token) return;
                point.status = 'moving';
                point.statusText = '이동 중';
                point.note = '드론 이동 중';
                await this.advanceFlow(mission, `move-${point.code}`, workflowStatusLabel('patrolRunning'), `${point.code} 이동`, `${point.code} 이동 중`, 700);

                if (this.activeRunToken !== token) return;
                point.status = 'capturing';
                point.statusText = '촬영 중';
                point.note = '기준값 자동 촬영 중';
                await this.advanceFlow(mission, `capture-${point.code}`, workflowStatusLabel('patrolRunning'), `${point.code} 기준값 촬영`, `${point.code} 자동 촬영 중`, 750);

                if (this.activeRunToken !== token) return;
                point.status = 'done';
                point.statusText = '촬영 완료';
                point.photos = point.photos || '2장';
                point.note = '기준값 자동 촬영 완료';
                mission.nextPointLabel = `${point.code} 촬영 완료`;
                await this.service.render();
                await this.service.sleep(250);
            }

            if (this.activeRunToken !== token) return;
            await this.advanceFlow(mission, 'return', workflowStatusLabel('patrolRunning'), '이륙 지점 복귀', '복귀 중', 650);
            if (this.activeRunToken !== token) return;
            await this.prepareUpload();
            await this.service.sleep(300);
            if (this.activeRunToken !== token) return;
            await this.startUpload();
        } finally {
            if (this.activeRunToken === token) {
                this.autoRunning = false;
                this.activeRunToken = '';
                await this.service.render();
            }
        }
    }

    public async markPointDone(point: any) {
        if (!this.activeMission || this.activeMission.stage !== 'capture' || !point || this.autoRunning) return;
        point.status = 'done';
        point.statusText = '촬영 완료';
        point.photos = point.photos || '2장';
        point.note = '수동 촬영 완료';
        if (this.allRequiredPointsComplete) {
            await this.prepareUpload();
            return;
        }
        this.refreshNextPointLabel(this.activeMission);
        await this.service.render();
    }

    public async requestRetake(point: any) {
        if (!this.activeMission || this.activeMission.stage !== 'capture' || !point || this.autoRunning) return;
        point.status = 'retake';
        point.statusText = '재촬영 필요';
        point.photos = '';
        point.note = '수동 개입으로 재촬영 필요 표시';
        this.refreshNextPointLabel(this.activeMission);
        await this.service.render();
    }

    public async prepareUpload() {
        if (!this.activeMission) return;
        const photoCount = this.requiredPointCount * 2;
        this.activeMission.stage = 'upload';
        this.activeMission.status = workflowStatusLabel('patrolRunning');
        this.activeMission.due = '촬영 결과 업로드';
        this.activeMission.currentFlowKey = 'upload';
        this.activeMission.nextPointLabel = '업로드 대기';
        this.activeMission.upload.progress = 0;
        this.activeMission.upload.status = '촬영본 업로드 대기';
        this.activeMission.upload.message = `${photoCount}장 촬영 완료 · 업로드 대기`;
        this.activeMission.upload.tempSaved = true;
        this.activeMission.upload.complete = false;
        this.activeMission.upload.retryable = false;
        this.activeMission.upload.aiStatus = '업로드 완료 후 AI 확인 필요';
        this.activeMission.upload.steps = [
            { label: '촬영 완료', value: `${photoCount}장` },
            { label: '복귀', value: '완료' },
            { label: '업로드', value: '대기' }
        ];
        await this.service.render();
    }

    public async startUpload() {
        if (!this.activeMission || this.activeMission.stage !== 'upload' || this.uploading) return;
        if (!this.allRequiredPointsComplete) return;
        const mission = this.activeMission;
        const photoCount = this.requiredPointCount * 2;
        this.uploading = true;
        mission.currentFlowKey = 'upload';
        mission.upload.retryable = false;
        mission.upload.tempSaved = true;
        mission.upload.complete = false;
        mission.upload.status = '업로드 중';
        mission.upload.message = `${photoCount}장 업로드 중`;
        mission.upload.steps = [
            { label: '촬영 완료', value: `${photoCount}장` },
            { label: '촬영자료', value: '전송 준비' },
            { label: '업로드', value: '진행 중' }
        ];

        const progressSteps = [24, 58, 84, 100];
        for (const progress of progressSteps) {
            mission.upload.progress = progress;
            if (progress === 24) mission.upload.status = '촬영자료 정리';
            if (progress === 58) mission.upload.status = '서버 전송 중';
            if (progress === 84) mission.upload.status = '메타데이터 등록';
            if (progress === 100) mission.upload.status = '업로드 완료';
            await this.service.render();
            await this.service.sleep(250);
        }

        mission.upload.tempSaved = false;
        mission.upload.complete = true;
        mission.upload.message = '업로드 완료 · AI 확인 항목 반영 중';
        mission.upload.steps = [
            { label: '촬영 완료', value: `${photoCount}장` },
            { label: '업로드', value: '완료' },
            { label: 'AI 확인', value: '반영 중' }
        ];
        await this.service.render();
        await this.confirmUploadRegistration(mission);
        this.uploading = false;
        await this.service.render();
    }

    private async confirmUploadRegistration(mission: any) {
        try {
            const response: any = await this.requestMissionCompletion(mission);
            if (this.isCompletionResponse(response)) {
                const caseCount = this.completionCaseCount(response);
                if (caseCount <= 0) {
                    this.applyUploadRetryState(mission, '업로드는 완료됐지만 AI 확인 항목 반영이 완료되지 않았습니다. 업로드 재시도를 눌러주세요.');
                    this.forgetCompletedMission(mission);
                    return;
                }
                this.applyCompletedMission(mission, caseCount);
                return;
            }
            this.applyUploadRetryState(mission, this.responseMessage(response, '업로드 완료 후 AI 확인 항목 반영에 실패했습니다. 다시 시도해주세요.'));
            this.forgetCompletedMission(mission);
        } catch (error) {
            this.applyUploadRetryState(mission, '업로드 완료 후 AI 확인 항목을 반영하는 중 오류가 발생했습니다. 다시 시도해주세요.');
            this.forgetCompletedMission(mission);
        }
    }

    private refreshNextPointLabel(mission: any) {
        mission.nextPointLabel = this.nextPointLabel(mission);
    }

    private nextPointLabel(mission: any) {
        if (!mission || !mission.points) return '관측 지점 없음';
        const point = mission.points.find((item) => item.required !== false && ['moving', 'capturing', 'pending', 'retake'].indexOf(item.status) >= 0);
        return point ? `${point.code} ${this.pointStatusText(point)}` : '촬영 완료';
    }

    public pointStatusText(point: any) {
        const status = String(point && point.status || 'pending');
        if (status === 'done') return '촬영 완료';
        if (status === 'moving') return '이동 중';
        if (status === 'capturing') return '촬영 중';
        if (status === 'retake') return '재촬영 필요';
        return '대기';
    }

    public tempSaveLabel() {
        if (!this.activeMission) return '';
        return this.activeMission.upload.tempSaved ? '전송 준비 중' : '촬영자료 업로드 완료';
    }

    public missionCardClass(mission: any) {
        if (mission.code === this.activeMission?.code) return 'border-emerald-700 bg-emerald-700 text-white shadow-sm';
        return 'border-zinc-200 bg-white text-zinc-800 hover:border-emerald-300 hover:bg-emerald-50/50';
    }

    public statusBadgeClass(mission: any) {
        return workflowStatusClass(this.missionWorkflowStatusKey(mission), mission && mission.code === this.activeMission?.code);
    }

    public missionStageLabel(mission: any) {
        if (!mission) return '';
        return workflowStatusLabel(this.missionWorkflowStatusKey(mission));
    }

    private missionWorkflowStatusKey(mission: any) {
        if (!mission) return 'assigned';
        if (mission.stage === 'completed') return 'ai';
        if (mission.stage === 'capture' || mission.stage === 'upload') return 'patrolRunning';
        return normalizeWorkflowStatusKey(mission.status || mission.stage || 'assigned');
    }

    public readinessCardClass(item: any) {
        if (item.ready) return 'border-emerald-200 bg-emerald-50 text-emerald-900';
        return 'border-amber-200 bg-amber-50 text-amber-900';
    }

    public readinessBadgeClass(item: any) {
        if (item.ready) return 'bg-emerald-700 text-white';
        return 'bg-amber-600 text-white';
    }

    public flowCardClass(step: any) {
        if (step.state === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-900';
        if (step.state === 'current') return 'border-sky-300 bg-sky-50 text-sky-950 ring-1 ring-sky-300';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public flowBadgeClass(step: any) {
        if (step.state === 'done') return 'bg-emerald-700 text-white';
        if (step.state === 'current') return 'bg-sky-700 text-white';
        return 'bg-white text-zinc-600';
    }

    public flowStatusText(step: any) {
        if (step.state === 'done') return '완료';
        if (step.state === 'current') return '진행 중';
        return '대기';
    }

    public commandPhaseClass() {
        if (this.commandPhase === 'ready') return 'border-emerald-200 bg-emerald-50 text-emerald-950';
        if (this.commandPhase === 'capture' || this.commandPhase === 'uploading' || this.commandPhase === 'upload') return 'border-sky-200 bg-sky-50 text-sky-950';
        if (this.commandPhase === 'ai') return 'border-zinc-300 bg-zinc-950 text-white';
        if (this.commandPhase === 'retry' || this.commandPhase === 'blocked') return 'border-amber-200 bg-amber-50 text-amber-950';
        return 'border-zinc-200 bg-zinc-50 text-zinc-900';
    }

    public commandPhaseBadgeClass() {
        if (this.commandPhase === 'ready') return 'border-emerald-200 bg-white text-emerald-700';
        if (this.commandPhase === 'capture' || this.commandPhase === 'uploading' || this.commandPhase === 'upload') return 'border-sky-200 bg-white text-sky-700';
        if (this.commandPhase === 'ai') return 'border-white/30 bg-white/15 text-white';
        if (this.commandPhase === 'retry' || this.commandPhase === 'blocked') return 'border-amber-200 bg-white text-amber-800';
        return 'border-zinc-200 bg-white text-zinc-700';
    }

    public operationStepClass(step: any) {
        if (step.state === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-900';
        if (step.state === 'current') return 'border-zinc-900 bg-zinc-950 text-white shadow-sm';
        return 'border-zinc-200 bg-zinc-50 text-zinc-500';
    }

    public operationStepBadgeClass(step: any) {
        if (step.state === 'done') return 'bg-emerald-700 text-white';
        if (step.state === 'current') return 'bg-white text-zinc-950';
        return 'bg-white text-zinc-500';
    }

    public primaryButtonClass() {
        if (this.primaryActionDisabled) return 'cursor-not-allowed bg-zinc-200 text-zinc-500';
        if (this.activeMission && this.activeMission.stage === 'upload' && this.activeMission.upload.retryable) return 'bg-amber-600 text-white shadow-sm hover:bg-amber-700';
        if (this.activeMission && this.activeMission.stage === 'completed') return 'bg-zinc-950 text-white shadow-sm hover:bg-zinc-800';
        return 'bg-emerald-700 text-white shadow-sm hover:bg-emerald-800';
    }

    public pointCardClass(point: any) {
        if (point.status === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-900';
        if (point.status === 'moving' || point.status === 'capturing') return 'border-sky-300 bg-sky-50 text-sky-950 ring-1 ring-sky-300';
        if (point.status === 'retake') return 'border-amber-200 bg-amber-50 text-amber-900';
        return 'border-zinc-200 bg-zinc-50 text-zinc-700';
    }

    public pointBadgeClass(point: any) {
        if (point.status === 'done') return 'bg-emerald-700 text-white';
        if (point.status === 'moving' || point.status === 'capturing') return 'bg-sky-700 text-white';
        if (point.status === 'retake') return 'bg-amber-600 text-white';
        return 'bg-white text-zinc-600';
    }

    public uploadStatusClass() {
        if (!this.activeMission) return 'border-zinc-200 bg-zinc-50 text-zinc-700';
        if (this.activeMission.stage === 'completed') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (this.activeMission.upload.retryable) return 'border-amber-200 bg-amber-50 text-amber-800';
        return 'border-sky-200 bg-sky-50 text-sky-700';
    }

    public progressClass(progress: number) {
        if (progress >= 100) return 'bg-emerald-600';
        if (progress > 0) return 'bg-sky-600';
        return 'bg-zinc-300';
    }
}

export default PageMissionsComponent;